import IcCheckDone from "@/assets/icons/ic-check-done.svg";

const STATUS_CONFIG: Record<string, { label: string; bg: string; text: string; icon?: string }> = {
  completed: {
    label: "답변완료",
    bg: "bg-[#43946C]",
    text: "text-[#000000]",
    // icon: IcCheckDone,
  },
  in_progress: {
    label: "처리 중",
    bg: "bg-[#FFAA72]",
    text: "text-[#000000]",
  },
};

interface InquiryStatusBadgeProps {
  status: string;
}

export function InquiryStatusBadge({ status }: InquiryStatusBadgeProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={`inline-flex w-fit items-center gap-1 rounded-[4px] px-2 lg:h-8 lg:px-3 text-[14px] h-6 tracking-[-0.01em] ${config.bg} ${config.text}`}
    >
      {config.label}
    </span>
  );
}
